var map = {
	"./AXP_Small.png": "./src/assets/icons/AXP_Small.png",
	"./GermanFlag.png": "./src/assets/icons/GermanFlag.png",
	"./SpainFlag.png": "./src/assets/icons/SpainFlag.png",
	"./TurkeyFlag.png": "./src/assets/icons/TurkeyFlag.png",
	"./UKFlag.png": "./src/assets/icons/UKFlag.png",
	"./USFlag.png": "./src/assets/icons/USFlag.png",
	"./addcategory.png": "./src/assets/icons/addcategory.png",
	"./addimage.png": "./src/assets/icons/addimage.png",
	"./addphoto.png": "./src/assets/icons/addphoto.png",
	"./apple_dark.png": "./src/assets/icons/apple_dark.png",
	"./apple_transparent.png": "./src/assets/icons/apple_transparent.png",
	"./asianoodle.png": "./src/assets/icons/asianoodle.png",
	"./back.png": "./src/assets/icons/back.png",
	"./backgray.png": "./src/assets/icons/backgray.png",
	"./backwhite.png": "./src/assets/icons/backwhite.png",
	"./barcodesearch.png": "./src/assets/icons/barcodesearch.png",
	"./bill.png": "./src/assets/icons/bill.png",
	"./bin.png": "./src/assets/icons/bin.png",
	"./bingray.png": "./src/assets/icons/bingray.png",
	"./binwhite.png": "./src/assets/icons/binwhite.png",
	"./box.png": "./src/assets/icons/box.png",
	"./bucket.png": "./src/assets/icons/bucket.png",
	"./cannedfood.png": "./src/assets/icons/cannedfood.png",
	"./cashpayment.png": "./src/assets/icons/cashpayment.png",
	"./categories Kopie.png": "./src/assets/icons/categories Kopie.png",
	"./categories.png": "./src/assets/icons/categories.png",
	"./category.png": "./src/assets/icons/category.png",
	"./categorycolored.png": "./src/assets/icons/categorycolored.png",
	"./checked.png": "./src/assets/icons/checked.png",
	"./checked_filled.png": "./src/assets/icons/checked_filled.png",
	"./checked_green.png": "./src/assets/icons/checked_green.png",
	"./checkmark.png": "./src/assets/icons/checkmark.png",
	"./chinesenoodle.png": "./src/assets/icons/chinesenoodle.png",
	"./close.png": "./src/assets/icons/close.png",
	"./close_gray.png": "./src/assets/icons/close_gray.png",
	"./closedsign.png": "./src/assets/icons/closedsign.png",
	"./closered.png": "./src/assets/icons/closered.png",
	"./closewhite.png": "./src/assets/icons/closewhite.png",
	"./closinghours.png": "./src/assets/icons/closinghours.png",
	"./coffeemug.png": "./src/assets/icons/coffeemug.png",
	"./commission.png": "./src/assets/icons/commission.png",
	"./contractaccept.png": "./src/assets/icons/contractaccept.png",
	"./contractaccept_gray.png": "./src/assets/icons/contractaccept_gray.png",
	"./cookie.png": "./src/assets/icons/cookie.png",
	"./cookie_old.png": "./src/assets/icons/cookie_old.png",
	"./cooking.png": "./src/assets/icons/cooking.png",
	"./cookingV2.png": "./src/assets/icons/cookingV2.png",
	"./cookingV3.png": "./src/assets/icons/cookingV3.png",
	"./cooking_chef.png": "./src/assets/icons/cooking_chef.png",
	"./credit-card.png": "./src/assets/icons/credit-card.png",
	"./customer-service.png": "./src/assets/icons/customer-service.png",
	"./customerservice.png": "./src/assets/icons/customerservice.png",
	"./dairyproducts.png": "./src/assets/icons/dairyproducts.png",
	"./dashboard.png": "./src/assets/icons/dashboard.png",
	"./de-pp-logo-150px.png": "./src/assets/icons/de-pp-logo-150px.png",
	"./debitcard.png": "./src/assets/icons/debitcard.png",
	"./deliveryscooter.png": "./src/assets/icons/deliveryscooter.png",
	"./desert.png": "./src/assets/icons/desert.png",
	"./diagram.png": "./src/assets/icons/diagram.png",
	"./discount_darkgreen.png": "./src/assets/icons/discount_darkgreen.png",
	"./discount_orange.png": "./src/assets/icons/discount_orange.png",
	"./distribution.png": "./src/assets/icons/distribution.png",
	"./dotteddownarrow.png": "./src/assets/icons/dotteddownarrow.png",
	"./downarrow.png": "./src/assets/icons/downarrow.png",
	"./download.png": "./src/assets/icons/download.png",
	"./email.png": "./src/assets/icons/email.png",
	"./email_blue.png": "./src/assets/icons/email_blue.png",
	"./error.png": "./src/assets/icons/error.png",
	"./error_filled.png": "./src/assets/icons/error_filled.png",
	"./error_red.png": "./src/assets/icons/error_red.png",
	"./facebook.png": "./src/assets/icons/facebook.png",
	"./food-delivery.png": "./src/assets/icons/food-delivery.png",
	"./franchise.png": "./src/assets/icons/franchise.png",
	"./fruits.png": "./src/assets/icons/fruits.png",
	"./giftbox_64x.png": "./src/assets/icons/giftbox_64x.png",
	"./globe.png": "./src/assets/icons/globe.png",
	"./google.png": "./src/assets/icons/google.png",
	"./greenstatusdot.png": "./src/assets/icons/greenstatusdot.png",
	"./handshake.png": "./src/assets/icons/handshake.png",
	"./hibernation.png": "./src/assets/icons/hibernation.png",
	"./hierarchical-structure.png": "./src/assets/icons/hierarchical-structure.png",
	"./home_white.png": "./src/assets/icons/home_white.png",
	"./hourglass.png": "./src/assets/icons/hourglass.png",
	"./infogray.png": "./src/assets/icons/infogray.png",
	"./information.png": "./src/assets/icons/information.png",
	"./information_blue.png": "./src/assets/icons/information_blue.png",
	"./klarna_official_badge.png": "./src/assets/icons/klarna_official_badge.png",
	"./lastschrift.png": "./src/assets/icons/lastschrift.png",
	"./law.png": "./src/assets/icons/law.png",
	"./leaves.png": "./src/assets/icons/leaves.png",
	"./ledger.png": "./src/assets/icons/ledger.png",
	"./location.png": "./src/assets/icons/location.png",
	"./log-out.png": "./src/assets/icons/log-out.png",
	"./logout.png": "./src/assets/icons/logout.png",
	"./logoutgray.png": "./src/assets/icons/logoutgray.png",
	"./magnifying-glass.png": "./src/assets/icons/magnifying-glass.png",
	"./map.png": "./src/assets/icons/map.png",
	"./market.png": "./src/assets/icons/market.png",
	"./marketing.png": "./src/assets/icons/marketing.png",
	"./menu.png": "./src/assets/icons/menu.png",
	"./mountain.png": "./src/assets/icons/mountain.png",
	"./navigation.png": "./src/assets/icons/navigation.png",
	"./noddlebox.png": "./src/assets/icons/noddlebox.png",
	"./nutrition.png": "./src/assets/icons/nutrition.png",
	"./onlinepayment.png": "./src/assets/icons/onlinepayment.png",
	"./onlineshopping.png": "./src/assets/icons/onlineshopping.png",
	"./optionline.png": "./src/assets/icons/optionline.png",
	"./options.png": "./src/assets/icons/options.png",
	"./orangestatusdot.png": "./src/assets/icons/orangestatusdot.png",
	"./package.png": "./src/assets/icons/package.png",
	"./paper.png": "./src/assets/icons/paper.png",
	"./paypal-mark-color.svg": "./src/assets/icons/paypal-mark-color.svg",
	"./paypal.png": "./src/assets/icons/paypal.png",
	"./paypal_icon.png": "./src/assets/icons/paypal_icon.png",
	"./peanut.png": "./src/assets/icons/peanut.png",
	"./pen.png": "./src/assets/icons/pen.png",
	"./photo-gallery.png": "./src/assets/icons/photo-gallery.png",
	"./pin.png": "./src/assets/icons/pin.png",
	"./pindark.png": "./src/assets/icons/pindark.png",
	"./pinwhite.png": "./src/assets/icons/pinwhite.png",
	"./placeholder.png": "./src/assets/icons/placeholder.png",
	"./plus.png": "./src/assets/icons/plus.png",
	"./pos-terminal.png": "./src/assets/icons/pos-terminal.png",
	"./privacy.png": "./src/assets/icons/privacy.png",
	"./privacy_gray.png": "./src/assets/icons/privacy_gray.png",
	"./product-management.png": "./src/assets/icons/product-management.png",
	"./product.png": "./src/assets/icons/product.png",
	"./productboxes.png": "./src/assets/icons/productboxes.png",
	"./queue.png": "./src/assets/icons/queue.png",
	"./redstatusdot.png": "./src/assets/icons/redstatusdot.png",
	"./save.png": "./src/assets/icons/save.png",
	"./scooter.png": "./src/assets/icons/scooter.png",
	"./settings.png": "./src/assets/icons/settings.png",
	"./settingscolored.png": "./src/assets/icons/settingscolored.png",
	"./settingsgear.png": "./src/assets/icons/settingsgear.png",
	"./settingsgeargray.png": "./src/assets/icons/settingsgeargray.png",
	"./shield.png": "./src/assets/icons/shield.png",
	"./shopping-bag.png": "./src/assets/icons/shopping-bag.png",
	"./shopping-bag_alt.png": "./src/assets/icons/shopping-bag_alt.png",
	"./shopping-bag_gray.png": "./src/assets/icons/shopping-bag_gray.png",
	"./shopping-cart.png": "./src/assets/icons/shopping-cart.png",
	"./shoppingcart_white.png": "./src/assets/icons/shoppingcart_white.png",
	"./shoppingcart_white_full.png": "./src/assets/icons/shoppingcart_white_full.png",
	"./shoppingcart_white_fullv2.png": "./src/assets/icons/shoppingcart_white_fullv2.png",
	"./shoppingcart_white_fullv2_old.png": "./src/assets/icons/shoppingcart_white_fullv2_old.png",
	"./shoppingcart_white_old.png": "./src/assets/icons/shoppingcart_white_old.png",
	"./shopstore.png": "./src/assets/icons/shopstore.png",
	"./sleeping.png": "./src/assets/icons/sleeping.png",
	"./star Kopie.png": "./src/assets/icons/star Kopie.png",
	"./star.png": "./src/assets/icons/star.png",
	"./stardark Kopie.png": "./src/assets/icons/stardark Kopie.png",
	"./stardark.png": "./src/assets/icons/stardark.png",
	"./stargray Kopie.png": "./src/assets/icons/stargray Kopie.png",
	"./stargray.png": "./src/assets/icons/stargray.png",
	"./store.png": "./src/assets/icons/store.png",
	"./support.png": "./src/assets/icons/support.png",
	"./tag.png": "./src/assets/icons/tag.png",
	"./tagdark.png": "./src/assets/icons/tagdark.png",
	"./take-away.png": "./src/assets/icons/take-away.png",
	"./team.png": "./src/assets/icons/team.png",
	"./terminal.png": "./src/assets/icons/terminal.png",
	"./timeandcalendar.png": "./src/assets/icons/timeandcalendar.png",
	"./timeleftgray.png": "./src/assets/icons/timeleftgray.png",
	"./timer.png": "./src/assets/icons/timer.png",
	"./trade.png": "./src/assets/icons/trade.png",
	"./truckdelivery.png": "./src/assets/icons/truckdelivery.png",
	"./tune.png": "./src/assets/icons/tune.png",
	"./unchecked.png": "./src/assets/icons/unchecked.png",
	"./undo.png": "./src/assets/icons/undo.png",
	"./uparrow.png": "./src/assets/icons/uparrow.png",
	"./user.png": "./src/assets/icons/user.png",
	"./user_white.png": "./src/assets/icons/user_white.png",
	"./vegetable.png": "./src/assets/icons/vegetable.png",
	"./visa_brandmark_-6x.png": "./src/assets/icons/visa_brandmark_-6x.png",
	"./viveel_logo128x128.png": "./src/assets/icons/viveel_logo128x128.png",
	"./voucher.png": "./src/assets/icons/voucher.png",
	"./warning.png": "./src/assets/icons/warning.png",
	"./wheat.png": "./src/assets/icons/wheat.png",
	"./worker.png": "./src/assets/icons/worker.png",
	"./workingtime.png": "./src/assets/icons/workingtime.png",
	"./yellowstatusdot.png": "./src/assets/icons/yellowstatusdot.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";